<template>
  <div :class="$style.page">
    <!-- 基础信息 -->
    <Loading :loading="loading" text="">
      <Card :showTop="false" :class="$style.base">
        <div :class="$style.base_content">
          <div :class="$style.base_left">
            <div :class="$style.base_left_top">
              {{ getTimeTip() }}
              <span :class="$style.nickname">{{
                accountInfo.nickName
                  ? accountInfo.nickName
                  : accountInfo.userName
                  ? accountInfo.userName
                  : userInfo.id
              }}</span>
              <span :class="$style.identity"> {{ accountInfo.levelName }}</span>
            </div>

            <div :class="$style.base_left_bottom">
              上次登录：
              <span :class="$style.time">{{ accountInfo.lastLoginTime }}</span>
              <span :class="$style.ip">{{ accountInfo.lastLoginIp }}</span>
              <span :class="$style.address">
                ({{ accountInfo.lastAddr }})
              </span>
            </div>
          </div>
          <div :class="$style.base_right">
            <img
              src="@assets/image/person.png"
              alt="person"
              @click="goPersonal"
            />
            <img
              src="@assets/image/mobile.png"
              alt="mobile"
              @click="goSecurity"
            />
            <img
              src="@assets/image/message.png"
              alt="message"
              @click="goEmail"
            />
          </div>
        </div>
      </Card>

      <!-- 钱币相关 -->
      <div :class="$style.money">
        <Card title="我的钱包" :class="$style.wallet">
          <template v-slot:actions>
            <Button type="primary" size="small" round @click="toRecharge">
              充值
            </Button>
            <Button type="blue" size="small" round @click="toWithdrawal">
              提现
            </Button>
          </template>

          <div :class="$style.card_content">
            <div :class="$style.card_item">
              <div :class="$style.card_item_count">
                {{ amountInfo.restAmount }}
              </div>
              <div :class="$style.card_item_name">可用余额</div>
            </div>
            <div :class="$style.card_item">
              <div :class="$style.card_item_count">
                {{ amountInfo.freezeAmount }}
              </div>
              <div :class="$style.card_item_name">冻结余额</div>
            </div>
            <div :class="$style.card_item">
              <div :class="$style.card_item_count">
                {{ accountInfo.scores }}
              </div>
              <div :class="$style.card_item_name">积分</div>
            </div>
          </div>
        </Card>

        <Card title="我的收入" :class="$style.income">
          <div :class="$style.card_content">
            <div :class="$style.card_item">
              <div :class="$style.card_item_count">
                {{ accountInfo.biddingIncome }}
              </div>
              <div :class="$style.card_item_name">竞价收入</div>
            </div>
            <div :class="$style.card_item">
              <div :class="$style.card_item_count">
                {{ accountInfo.fixedPriceIncome }}
              </div>
              <div :class="$style.card_item_name">一口价收入</div>
            </div>
            <div :class="$style.card_item">
              <div :class="$style.card_item_count">
                {{ accountInfo.agentIncome }}
              </div>
              <div :class="$style.card_item_name">代理收入</div>
            </div>
          </div>
        </Card>
      </div>

      <!-- 我的域名 -->
      <Card title="我的域名">

        <div :class="$style.domain_content">
          <template v-for="(item, index) in myDN">
            <router-link
              :class="$style.domain_item"
              :key="index"
              :to="item.path"
            >
              <div>{{ item.name }}</div>
              <div :class="$style.domain_item_number">{{ item.number }}</div>
            </router-link>
          </template>
        </div>
      </Card>
    </Loading>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Card from "@components/Card.vue";

export default {
  name: "UserCenter",
  components: { Card },
  data() {
    return {
      loading: false,
      myDN: [
        {
          name: "域名总数",
          number: 0,
          path: "/user/my-domain",
        },
        {
          name: "即将到期的域名",
          number: 0,
          path: "/user/my-domain?tab=1",
        },
        {
          name: "已到期域名",
          number: 0,
          path: "/user/my-domain?tab=2",
        },
        {
          name: "赎回期域名",
          number: 0,
          path: "/user/my-domain?tab=3",
        },
        {
          name: "正在转入",
          number: 0,
          path: "/user/domain-enter?activeName=second&tab=1",
        },
        {
          name: "正在转出",
          number: 0,
          path: "/user/domain-out?activeName=second",
        },
        {
          name: "等待接收的PUSH",
          number: 0,
          path: "/user/domain-push?activeName=second",
        },
        {
          name: "我发出的PUSH",
          number: 0,
          path: "/user/domain-push?activeName=third",
        },
        {
          name: "域名模板",
          number: 0,
          path: "/user/my-template",
        },
      ],
    };
  },
  computed: {
    ...mapState("user", ["userInfo", "accountInfo", "amountInfo"]),
  },
  created() {
    this.initData();
  },
  mounted() {
    // 我的域名
    this.myDN[0].number = this.accountInfo.domainCount;
    this.myDN[1].number = this.accountInfo.expiringCount;
    this.myDN[2].number = this.accountInfo.expiredCount;
    this.myDN[3].number = this.accountInfo.redeemCount;
    this.myDN[4].number = this.accountInfo.transferIntoCount;
    this.myDN[5].number = this.accountInfo.transferOutCount;
    this.myDN[6].number = this.accountInfo.waitPushCount;
    this.myDN[7].number = this.accountInfo.sendPushCount;
    this.myDN[8].number = this.accountInfo.domainTemplateCount;
  },
  methods: {
    ...mapActions("user", ["getAccountInfoAction"]),

    async initData() {
      this.loading = true;
      await this.getAccountInfoAction();
      this.loading = false;
    },
    // 个人资料
    goPersonal() {
      this.$router.push("/user/detail");
    },
    // 安全中心
    goSecurity() {
      this.$router.push("/user/safe");
    },
    // 邮箱认证
    goEmail() {
      this.$router.push("/user/certify-email");
    },
    getTimeTip() {
      const hour = new Date().getHours();
      let tip = "早上好，";

      if (hour > 18) {
        tip = "晚上好，";
      } else if (hour > 13) {
        tip = "下午好，";
      } else if (hour > 12) {
        tip = "中午好，";
      } else if (hour > 8) {
        tip = "上午好，";
      }

      return tip;
    },

    toRecharge() {
      this.$router.push("/user/recharge");
    },

    toWithdrawal() {
      this.$router.push("/user/withDrawal");
    }
  },
};
</script>

<style lang="scss" module scoped>
.page {
  .base {
    height: rem(120);
    padding: rem(20) rem(50);

    .base_content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .base_left {
      .base_left_top {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        height: rem(43);
        font-size: rem(18);
        color: #000000;

        .nickname {
          min-width: rem(120);
        }

        .identity {
          width: rem(80);
          padding: 5px 10px;
          min-width: 60px;
          height: rem(26);
          margin-left: rem(20);
          font-size: rem(14);
          color: $white;
          line-height: rem(26);
          text-align: center;
          background: $theme-blue-color;
          border-radius: 20px;
        }
      }

      .base_left_bottom {
        margin-top: rem(10);
        font-size: rem(14);
        color: #666;
        line-height: rem(34);

        .ip {
          margin-left: rem(50);
        }
        .address {
          margin-left: rem(10);
        }
      }
    }

    .base_right {
      @include flex();

      & > img {
        width: 30px;
        height: 30px;
        cursor: pointer;

        &:not(:last-child) {
          margin-right: 20px;
        }
      }
    }
  }

  .card_content {
    display: flex;
    justify-content: space-between;
    padding: rem(30) 0;

    .card_item {
      min-width: 100px;
      @include flex();
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #333;

      .card_item_count {
        font-size: rem(36);
        font-family: DINSchrift;
      }

      .card_item_name {
        margin-top: rem(20);
        font-size: rem(14);
      }
    }
  }

  .money {
    display: flex;
    justify-content: space-between;

    .wallet {
      width: rem(840);
      margin-right: rem(30);

      .card_content {
        .card_item:first-child .card_item_count {
          color: $theme-blue-color;
        }
      }
    }

    .income {
      width: rem(640);
    }
  }

  .btn_all {
    font-size: rem(14);
    color: $theme-blue-color;
    cursor: pointer;
  }

  .domain_content {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: rem(20) 0 rem(30);
    gap: rem(20) rem(35);

    .domain_item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      width: calc((100% - rem(140)) / 5);
      height: rem(60);
      padding: 0 rem(30);
      font-size: rem(14);
      color: #333333;
      background: #f7f7fa;
      transition: all 0.15s;

      &:nth-child(5n) {
        margin-right: 0;
      }

      &:hover {
        transform: scale(1.1);
        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
        background: #fff;
      }

      .domain_item_number {
        font-weight: bold;
        color: $theme-color;
      }
    }
  }
}
</style>
